/**
 * TransferCancelForm Component
 *
 * Cancel confirmation form with reason textarea.
 * @see Sprint 14 - Transferts Inter-Sites
 */

import { Button, Textarea } from '@/components/ui';

interface TransferCancelFormProps {
  cancelReason: string;
  onReasonChange: (value: string) => void;
  onConfirm: () => void;
  onBack: () => void;
  isPending: boolean;
}

export function TransferCancelForm({
  cancelReason,
  onReasonChange,
  onConfirm,
  onBack,
  isPending,
}: TransferCancelFormProps) {
  return (
    <div className="border-t border-neutral-200 pt-6 bg-danger-50 -mx-6 px-6 pb-6">
      <h3 className="text-sm font-medium text-danger-700 mb-3">Annuler le transfert</h3>
      <Textarea
        placeholder="Raison de l'annulation..."
        value={cancelReason}
        onChange={(e) => onReasonChange(e.target.value)}
        rows={3}
      />
      <div className="flex gap-2 mt-3">
        <Button
          variant="danger"
          onClick={onConfirm}
          disabled={!cancelReason.trim() || isPending}
        >
          Confirmer l'annulation
        </Button>
        <Button
          variant="secondary"
          onClick={onBack}
        >
          Retour
        </Button>
      </div>
    </div>
  );
}
